export default {
  namespaced: true,
  state: {
    helpReferencesMap: {},
  },
  mutations: {
    addHelpReference(state, helpReference) {
      state.helpReferencesMap = {
        ...state.helpReferencesMap,
        [helpReference.identifier]: helpReference,
      };
    },
  },
};
